export default {"src":"/_next/static/media/arrow-left.6e32dfa9.svg","height":17,"width":10};